<div class="flex justify-between items-center mb-2">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Cadastro de Serviços</h1>
    </div>
  </div>

<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto bg-white">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="md:col-span-2">
            <label class="block mb-1 font-medium">Nome do Serviço <span class="text-red-500">*</span></label>
            <input
              pInputText
              formControlName="name"
              placeholder="Digite o nome do serviço"
              class="w-full"
            />
          </div>

          <div class="md:col-span-2">
            <label class="block mb-1 font-medium">Descrição</label>
            <input
              pInputText
              formControlName="description"
              placeholder="Digite a descrição"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Preço (R$) <span class="text-red-500">*</span></label>
            <p-inputNumber
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              [minFractionDigits]="2"
              formControlName="price"
              class="w-full"
              [inputStyle]="{ width: '100%' }"
            />
          </div>

          <div class="flex items-center mt-6">
            <p-checkbox 
              formControlName="active"
              binary="true"
              inputId="cbActive">
            </p-checkbox>
            <label for="cbActive" class="ml-2">Ativo</label>
          </div>
        </div>

    <!-- Botões -->
    <div class="flex justify-end gap-3 mt-6">
      <button (click)="goBack()" type="button" class="border px-4 py-2 border-orange-500 cursor-pointer rounded hover:bg-orange-50">Cancelar</button>
      <button
        type="submit"
        class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
        [disabled]="form.invalid"
      >
        {{ isEditMode ? 'Salvar' : 'Cadastrar' }}
      </button>
    </div>
  </form>
</div>

